import {Box, Typography} from '@mui/material';
import {t} from 'i18next';
import ArrIconButton from '../../../../common/arr-icon-button/ArrIconButton';
import {ReactComponent as ExpandCollapseIcon} from '../../../../../assets/images/expand-collapse-icon.svg';
import {
  CASE_CONTEXT_TOC_SECTIONS,
  CaseContextTocSectionId,
} from './caseContextConfig';

interface CaseContextTOCProps {
  activeSectionId: CaseContextTocSectionId;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  onSectionSelect: (sectionId: CaseContextTocSectionId) => void;
}

const CaseContextTOC = ({
  activeSectionId,
  isCollapsed,
  onToggleCollapse,
  onSectionSelect,
}: CaseContextTOCProps) => (
  <Box
    className={`case-context-toc ${isCollapsed ? 'case-context-toc--collapsed' : ''}`}
    data-testid="case-context-toc"
  >
    <Box className="case-context-toc__header">
      {!isCollapsed && (
        <Typography
          component="h2"
          className="case-context-toc__heading typo-text subhead2_size"
          data-testid="case-context-toc-heading"
          id="case-context-toc-heading"
        >
          {t('ai.review.protocolWizard.caseContext.tocHeading')}
        </Typography>
      )}
      <ArrIconButton
        icon={<ExpandCollapseIcon />}
        ariaLabel={
          isCollapsed
            ? t('ai.review.protocolWizard.caseContext.expandToc')
            : t('ai.review.protocolWizard.caseContext.collapseToc')
        }
        shape="none"
        className="case-context-toc__collapse-btn"
        testId="case-context-toc-collapse"
        onClick={onToggleCollapse}
      />
    </Box>

    {!isCollapsed && (
      <Box
        className="case-context-toc__list"
        role="navigation"
        aria-labelledby="case-context-toc-heading"
      >
        {CASE_CONTEXT_TOC_SECTIONS.map((section) => {
          const isActive = section.id === activeSectionId;

          return (
            <button
              key={section.id}
              type="button"
              className={`case-context-toc__item typo-text label1_size  ${isActive ? 'case-context-toc__item--active' : ''}`}
              onClick={() => onSectionSelect(section.id)}
              data-testid={`case-context-toc-item-${section.id}`}
              aria-current={isActive ? 'true' : undefined}
            >
              {t(section.titleKey)}
            </button>
          );
        })}
      </Box>
    )}
  </Box>
);

export default CaseContextTOC;
